import {Link} from 'react-router-dom';

export function SectionHeader({title, subtitle, to = '/catalog', action = 'View all'}) {
  return <header className="section-head ui-section-head"><div><h2>{title}</h2>{subtitle ? <p>{subtitle}</p> : null}</div>{to ? <Link to={to}>{action} <span aria-hidden="true">→</span></Link> : null}</header>;
}

export function PageHeader({title, eyebrow, description, actions}) {
  return <header className="ui-page-header"><div>{eyebrow ? <span>{eyebrow}</span> : null}<h1>{title}</h1>{description ? <p>{description}</p> : null}</div>{actions ? <div className="ui-page-actions">{actions}</div> : null}</header>;
}
